module.exports = __webpack_public_path__ + "img/IMG_9531.d83b3344.jpg";